export default __webpack_public_path__ + "static/media/Emojis20.2733bde0.png";